import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { MobileNav } from './MobileNav'
import { Sidebar } from './Sidebar'
import { TopBar } from './TopBar'

export interface AppShellProps {
  userName: string
  userEmail: string
  onLogout: () => void
}

/** Carries the three admin views (dashboard, users, settings) that tasks 7
    and 8 fill in — this file only lays the frame around <Outlet />. */
export function AppShell({ userName, userEmail, onLogout }: AppShellProps) {
  const [mobileOpen, setMobileOpen] = useState(false)

  return (
    <div className="flex h-dvh overflow-hidden bg-sheet">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <TopBar
          userName={userName}
          userEmail={userEmail}
          onLogout={onLogout}
          menuOpen={mobileOpen}
          onOpenMenu={() => setMobileOpen(true)}
        />
        <main className="min-h-0 flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
      <MobileNav open={mobileOpen} onOpenChange={setMobileOpen} />
    </div>
  )
}
